import { useEffect, useState } from "react";

export interface MarketingForm {
  id: string;
  name: string;
  formType?: string;
  archived?: boolean;
}

interface ApiResponse {
  results?: MarketingForm[];
}

export function useForms(portalId: string | null) {
  const [items, setItems] = useState<MarketingForm[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!portalId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetch(`/api/forms-list/${portalId}`, { credentials: "include" })
      .then(async (res) => {
        const body = (await res.json()) as ApiResponse & { error?: string };
        if (!res.ok) throw new Error(body.error ?? `HTTP ${res.status}`);
        return body;
      })
      .then((body) => {
        if (cancelled) return;
        setItems((body.results ?? []).filter((f) => !f.archived));
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : "Unknown error");
        setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [portalId]);

  return { items, loading, error };
}
